import React from 'react';
import NavBar from "../../components/Navbar/NavBar";
import FooterOne from "../../components/Footer/Footer";
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import { Box, Button, Container, Grid, Typography, useTheme, useMediaQuery } from '@mui/material';
import { schoolSponsorshipImages } from '../../utils/BeadsData';

const SchoolSponsorships = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <NavBar />
            <Container sx={{ mt: 12, mx: 'auto', mb: isMobile ? 2 : 8 }}>
                <Typography variant="h4" gutterBottom sx={{ my: 3, textAlign: 'center', fontWeight: 'bold' }}>School Sponsorships for Kenyan Girls</Typography>

                <Typography paragraph>
                    Since 1998, a total of over 500 girls in Kenya are getting or have gotten an education thanks to generous BEADS sponsors! Learn more and join in a life-changing experience -- for both your sponsored girls and yourself.
                </Typography>

                <Grid container spacing={5} justifyContent="center" sx={{ mt: 2 }}>
                    <Grid item xs={12} md={8}>
                        <Swiper
                            modules={[Autoplay, EffectFade]}
                            effect="fade"
                            autoplay={{ delay: 5000, disableOnInteraction: false }}
                            loop={true}
                            style={{ borderRadius: '2rem' }}
                        >
                            {schoolSponsorshipImages.map((image, index) => (
                                <SwiperSlide key={index}>
                                    <Box sx={{ position: 'relative', height: isMobile ? 320 : 520 }}>
                                        <img src={image.src} alt={image.alt}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        <Typography
                                            variant={isMobile ? "body2" : "subtitle1"}
                                            sx={{
                                                position: 'absolute',
                                                bottom: 0,
                                                width: '100%',
                                                color: 'white',
                                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                padding: '6px',
                                                textAlign: 'center',
                                                fontSize: isMobile ? '0.75rem' : '1rem',
                                            }}
                                        >
                                            {image.description}
                                        </Typography>
                                    </Box>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Box sx={{ m: 'auto', borderRadius: '2rem', p: 3 }}>
                            <Box sx={{ background: '#f8fafd', mb: 3, border: '1px solid #cfcfcf', borderRadius: '2rem', p: 2 }}>
                                <Typography variant="h6" gutterBottom align="center" fontWeight="bold">
                                    WITHOUT AN EDUCATION;
                                </Typography>
                                <Typography variant="body1" paragraph>
                                    A Maasai girl will remain illiterate and unable to support herself or her family. She will probably be forced into marriage at age 15 to a much older man, and be his second or third wife. Starting in her teens, she will bear an average of 7 or more children.
                                </Typography>
                            </Box>

                            <Box sx={{ background: '#f8fafd', border: '1px solid #cfcfcf', borderRadius: '2rem', p: 2 }}>
                                <Typography variant="h6" gutterBottom align="center" fontWeight="bold">
                                    WITH AN EDUCATION;
                                </Typography>
                                <Typography variant="body1" paragraph>
                                    A girl can have a career of her choosing, and she can improve her family's standard of living. She will likely be the sole wife of a man she chooses, and she will have far fewer children and be more likely to education them, both boys and girls.
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>

                </Grid>
            </Container>

            <Grid container direction="column" alignItems="center" sx={{ my: 8, mx: 'auto', p: 3, background: '#f8f9fc', boxShadow: '3px 4px 8px rgba(0,0,0,0.1)' }}>
                <Typography variant="h5" gutterBottom align="center" fontWeight="bold" sx={{ mt: 5, mb: 2 }}>TOGETHER WE ARE CHANGING LIVES -- ONE GIRL AT A TIME.</Typography>

                <Box textAlign="center" >
                    <Typography>
                        For more information or to select a girl to sponsor, contact Debby Rooney at
                        <Typography
                            component="a"
                            href="mailto:BEADSofKenya@aol.com"
                            sx={{
                                color: '#007bff',
                                marginLeft: '5px',
                                marginRight: '5px',
                                textDecoration: 'none',
                                ':hover': {
                                    color: '#0056b3',
                                },
                            }}
                        >
                            BEADSofKenya@aol.com
                        </Typography>
                        or by calling <strong>(US) 609-992-7891.</strong>
                    </Typography>

                    <Typography paragraph>You can also learn more by clicking below.</Typography>

                    <Button className='btn btn-border-base' variant="contained" align="center"
                        onClick={() => navigate('/donate')}
                        sx={{
                            mt: 2,
                            borderRadius: 15,
                            textAlign: 'center',
                            width: isMobile ? '80%' : 'auto',
                            fontSize: isMobile ? '0.75rem' : '1rem',
                        }}>
                        Learn More
                    </Button>
                </Box>
            </Grid>
            <FooterOne />
        </Box>
    );
};

export default SchoolSponsorships;
